import { formatMoney } from '../../../../../shared/policies/format-money';
import type { RateLineProposalQueueView } from '../../../rate-cards.api';

function Side({ label, price, window }: { label: string; price: string; window: string }) {
  return (
    <div className="min-w-0">
      <p className="text-xs text-muted">{label}</p>
      <p className="font-medium">{price}</p>
      <p className="text-xs text-muted">{window}</p>
    </div>
  );
}

const windowOf = (validFrom: string, validTo: string | null) => `${validFrom} to ${validTo ?? 'open-ended'}`;

/**
 * A price change shows what is in force now beside what is proposed. A new line has nothing to compare against, so it
 * reads as new, with no diff. If the line a change would replace is gone from the response, it says so rather than inventing one.
 */
export function ProposalDiff({ proposal }: { proposal: RateLineProposalQueueView }) {
  const proposed = <Side label="Proposed" price={formatMoney(proposal.amount)} window={windowOf(proposal.validFrom, proposal.validTo)} />;
  if (proposal.kind === 'create') return proposed;

  const { previousLine } = proposal;
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
      {previousLine ? (
        <Side label="Current" price={formatMoney(previousLine.amount)} window={windowOf(previousLine.validFrom, previousLine.validTo)} />
      ) : (
        <p className="text-xs text-muted">The line this replaces is no longer available</p>
      )}
      <span aria-hidden className="text-muted">
        →
      </span>
      {proposed}
    </div>
  );
}
